import React from 'react'

const Fifty_two = () => {
    return (
        <div className='container'>
            <h1>C Program Number Of Alphabets, Digits & Special Character In String </h1>
            <div className='containers'>
            C program to find the total number of alphabets, digits or special characters in a string <br />
           1) The ASCII values range of A to Z is 65 to 90, and a to z is 97 to 122 and 0 t0 9 is 48 to 57.<br />
2) Read the entered string and initialize to s.<br />
<br />
3) Iterate through string using for loop with the structure for(i=0;s[i];i++)<br />

If the ASCII value of s[i] is in the range between 65 to 90 or 97 to 122 then increase the alphabets count.<br />
<br />
If the ASCII value of s[i] is in the range between 48 to 57 then increase the digits count.<br />
<br />
If the ASCII value of s[i] is not in the range of the above two conditions then increase the special characters count.<br />
<br />
4) Print the alphabets count, digits count and special characters count.<br />
            </div>
            <div className='containers'>
          <code className='library'>  #include</code> &lt;string.h&gt;<br/>
 
  <code className='keywords'> int</code> main()<br/>
 &#123;<br/>
      <code className='keywords'> char</code> s[1000]; <br/>
      <code className='keywords'> int</code> i,alphabets=0,digits=0,specialcharacters=0;<br/>
  
      <code className='library'> printf</code>("Enter  the string : ");<br/>
     <code className='library'>  gets(s);</code><br/>
      
     <code className='keywords'>  for</code>(i=0;s[i];i++)  <br/>
     &#123;<br/>
         <code className='keywords'>  if</code>((s[i]&gt;=65 && s[i]&lt;=90)|| (s[i]&gt;=97 && s[i]&lt;=122) )<br/>
           alphabets++;<br/>
         <code className='keywords'>  else if</code>(s[i]&gt;=48 && s[i]&lt;=57)<br/>
          digits++;<br/>
         <code className='keywords'>  else</code><br/>
          specialcharacters++;<br/>
  
      &#125;<br/>
      
      
     <code className='library'>  printf</code>("Alphabets = %d\n",alphabets);<br/>
     <code className='library'>  printf</code>("Digits = %d\n",digits);<br/>
      <code className='library'> printf</code>("Special characters = %d", specialcharacters);<br/>
     
  
      <code className='library'> return</code> 0;<br/>
 &#125;<br/>
            </div>
        </div>
    )
}

export default Fifty_two
